(function () {
    'use strict';

    angular
        .module('jotApp')
        .filter('nullable', nullable);

    function nullable() {
        return nullableFilter;

        function nullableFilter(input, replace, empty) {
            if (replace === null || replace === undefined) {
                replace = '';
            }
            if (input === null || input === undefined || (empty && input === '')) {
                return replace;
            }
            return input;
        }
    }
})();
